'use client';

import {useEffect} from 'react';
import {track} from '@/lib/analytics';

/** Reports 404s to GA4 so broken (legacy) links can be found and redirected. */
const TrackNotFound = () => {
  useEffect(() => {
    track('page_not_found', {page_path: window.location.pathname});
  }, []);
  return null;
};

export default TrackNotFound;
